function toggleShopLookDrawer(blockId, shouldOpen) {
  const drawer = document.getElementById(`ShopLookDrawer-${blockId}`);
  if (!drawer) return;

  if (shouldOpen) {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
  } else {
    drawer.setAttribute('aria-hidden', 'true');
    const quickCartOpen = document.querySelector('quick-cart-drawer.is--open, quick-cart-drawer[open], .quick-cart-drawer__blocks.is--open');
    if (!quickCartOpen) {
      document.body.classList.remove('overflow-hidden');
    }
  }
}

function updateVariantPrice(selectElement) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const item = selectElement.closest('.shop-look-product-item');
  if (!item) return;

  const priceContainer = item.querySelector('.shop-look-product-item__price');
  if (priceContainer && selectedOption.dataset.price) {
    priceContainer.textContent = selectedOption.dataset.price;
  }

  const hasSize = selectElement.value !== '';

  const addButton = item.querySelector('.shop-look-product-item__add-btn');
  if (addButton) {
    addButton.disabled = !hasSize;
    addButton.classList.toggle('is--visible', hasSize);
  }

  const selectWrapper = selectElement.closest('[data-select-wrapper]');
  if (selectWrapper) {
    selectWrapper.classList.toggle('has-value', hasSize);
  }
}

function handleShopLookAddToCart(buttonElement) {
  const actionContainer = buttonElement.closest('.shop-look-product-item__actions');
  if (!actionContainer) return;

  let variantId = '';
  const hiddenInput = actionContainer.querySelector('.product-variant-id');
  const selectDropdown = actionContainer.querySelector('.product-variant-selector');

  if (hiddenInput) {
    variantId = hiddenInput.value;
  } else if (selectDropdown) {
    variantId = selectDropdown.value;
  }

  if (!variantId) return;

  const buttonText = buttonElement.querySelector('span');
  const spinner = buttonElement.querySelector('.btn-spinner');

  if (buttonText) buttonText.classList.add('hidden');
  if (spinner) spinner.classList.remove('hidden');
  buttonElement.setAttribute('disabled', 'true');

  const formData = {
    'id': parseInt(variantId),
    'quantity': 1,
    'sections': 'cart-drawer'
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(cartData => {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cartData }
    }));

    const releaseCartDrawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer') || document.querySelector('quick-cart-drawer');

    if (releaseCartDrawer) {
      if (cartData.sections && cartData.sections['cart-drawer'] && typeof releaseCartDrawer.renderContents === 'function') {
        releaseCartDrawer.renderContents(cartData);
      }

      document.dispatchEvent(new CustomEvent('cart:render', {
        bubbles: true,
        detail: cartData
      }));

      const openDrawer = buttonElement.closest('.shop-look-drawer');
      if (openDrawer) {
        openDrawer.setAttribute('aria-hidden', 'true');
      }

      setTimeout(() => {
        if (typeof releaseCartDrawer.open === 'function') {
          releaseCartDrawer.open();
        } else {
          releaseCartDrawer.classList.add('active', 'is--open');
          document.documentElement.classList.add('overflow-hidden');
          document.body.classList.add('overflow-hidden');
        }
      }, 150);

    } else {
      const openDrawer = buttonElement.closest('.shop-look-drawer');
      if (openDrawer) {
        openDrawer.setAttribute('aria-hidden', 'true');
      }

      setTimeout(() => {
        const cartHeaderButton = document.querySelector('#cart-icon-bubble, .header__icon--cart, [data-cart-drawer-trigger], .js-cart-trigger');
        if (cartHeaderButton) {
          cartHeaderButton.click();
        } else {
          window.location.href = '/cart';
        }
      }, 250);
    }
  })
  .catch((error) => {
    console.error('Cart Drawer Integration Error:', error);
    window.location.href = '/cart';
  })
  .finally(() => {
    if (buttonText) buttonText.classList.remove('hidden');
    if (spinner) spinner.classList.add('hidden');
    buttonElement.removeAttribute('disabled');
  });
}

function initShopLookMediaSliders() {
  document.querySelectorAll('[data-item-media]').forEach(media => {
    if (media.dataset.bound === 'true') return;
    media.dataset.bound = 'true';

    const track = media.querySelector('[data-media-track]');
    const prevButton = media.querySelector('[data-media-prev]');
    const nextButton = media.querySelector('[data-media-next]');
    if (!track) return;

    const slides = Array.from(track.children);
    if (slides.length < 2) {
      if (prevButton) prevButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
      return;
    }

    let index = 0;

    function goToSlide(animate) {
      const trackGap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = slides[0].getBoundingClientRect().width + trackGap;

      track.style.transition = animate ? '' : 'none';
      track.style.transform = `translateX(-${index * step}px)`;

      if (prevButton) prevButton.hidden = index === 0;
      if (nextButton) nextButton.hidden = index === slides.length - 1;
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        if (index === 0) return;
        index -= 1;
        goToSlide(true);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        if (index === slides.length - 1) return;
        index += 1;
        goToSlide(true);
      });
    }

    window.addEventListener('resize', () => goToSlide(false));
    goToSlide(false);
  });
}

function setupShopLookCarousel() {
  initShopLookMediaSliders();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initShopLookMediaSliders);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupShopLookCarousel);
} else {
  setupShopLookCarousel();
}
